import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES, waLink, WA_MESSAGES, WA_NUMBER_DISPLAY } from "@/lib/site";
import { Reveal, ArrowButton } from "@/components/landing/Reveal";

const FinalCta = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const bgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

    return (
        <section
            id="final-cta"
            data-testid="final-cta-section"
            ref={ref}
            className="relative overflow-hidden"
        >
            <motion.img
                src={IMAGES.finalCta}
                alt="Crowd at a concert under amber stage lights"
                loading="lazy"
                style={{ y: bgY }}
                className="absolute inset-0 h-[120%] w-full object-cover"
            />
            <div className="absolute inset-0 bg-[#050505]/75" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />

            <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-start px-5 py-32 md:px-10 md:py-48">
                <Reveal>
                    <span className="text-[11px] font-bold uppercase tracking-[0.4em] text-gold">
                        The night is waiting
                    </span>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-8 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ivory md:text-7xl">
                        READY FOR{" "}
                        <span className="italic text-gold">YOUR NIGHT?</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mt-6 font-serif text-xl italic text-ivory/70 md:text-2xl">
                        Your table is waiting.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
                        <ArrowButton
                            testId="final-book-vip-btn"
                            href={waLink(WA_MESSAGES.booking)}
                        >
                            Book My VIP Table
                        </ArrowButton>
                        <ArrowButton
                            testId="final-whatsapp-btn"
                            variant="secondary"
                            href={waLink(WA_MESSAGES.concierge)}
                        >
                            Chat on WhatsApp
                        </ArrowButton>
                    </div>
                </Reveal>
                <Reveal delay={0.25}>
                    <p
                        data-testid="final-whatsapp-number"
                        className="mt-10 text-[11px] font-semibold uppercase tracking-[0.35em] text-ivory/50"
                    >
                        WhatsApp <span className="mx-2 text-gold">•</span>{" "}
                        {WA_NUMBER_DISPLAY}
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default FinalCta;
